<template>
  <v-app id="adminpro" :class="`${!$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'}`">
      <router-view />
  </v-app>

</template>

<script>
import axios  from 'axios';

export default {
  name: 'App',

  components: {
    
  },
    created () {
    // Leer la información de estado en sessionStorage cuando se carga la página
    if (sessionStorage.getItem("store") ) {
        this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("store"))));
        axios.defaults.headers.post['Authorization'] =this.$store.state.headertoken;
    } 
 
         // Guarde la información en vuex en sessionStorage cuando se actualice la página
    window.addEventListener("beforeunload",()=>{
        sessionStorage.setItem("store",JSON.stringify(this.$store.state))
    })
  }

};
</script>
